@if ({
  searchRequest: searchRequest$ | async,
  }; as content) {
  <div class="container-search-pages">
    @if (!content.searchRequest?.isLoading) {
      @if (!content.searchRequest?.hasError) {
        @if (content.searchRequest?.literatures?.length) {
          <div class="pages-grid">
            @for (literature of content.searchRequest?.literatures; track literature) {
              <page-item [literature]="literature"></page-item>
            }
          </div>
          <div class="d-flex justify-content-center w-100 m-t-20">
            <cx-pagination [pagination]="content.searchRequest?.pagination" (viewPageEvent)="pageChange($event)"></cx-pagination>
          </div>
        } @else {
          <p class="text-center m-0" [innerHTML]="'generic.noContent' | cxTranslate: { term: currentTerm }"></p>
        }
      } @else {
        <alert [alert]="errorMessage"></alert>
      }
    } @else {
      <local-loader></local-loader>
    }
  </div>
}
